/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlStripeLinkResponse
 */
export interface ControlStripeLinkResponse {
    /**
     * 
     * @type {string}
     * @memberof ControlStripeLinkResponse
     */
    url: string;
}

/**
 * Check if a given object implements the ControlStripeLinkResponse interface.
 */
export function instanceOfControlStripeLinkResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "url" in value;

    return isInstance;
}

export function ControlStripeLinkResponseFromJSON(json: any): ControlStripeLinkResponse {
    return ControlStripeLinkResponseFromJSONTyped(json, false);
}

export function ControlStripeLinkResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlStripeLinkResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'url': json['url'],
    };
}

export function ControlStripeLinkResponseToJSON(value?: ControlStripeLinkResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'url': value.url,
    };
}

